import { defineMessages } from '@edx/frontend-platform/i18n'

const messages = defineMessages({
  courses: {
    id: "pages.learning.learner-program.courses",
    defaultMessage: "courses",
    description: "Courses count label"
  },
  contents: {
    id: "pages.learning.learner-program.contents",
    defaultMessage: "Courses",
    description: "Program Contents title"
  },
  noCoursesFound: {
    id: "pages.learning.learner-program.noCoursesFound",
    defaultMessage: "No courses found",
    description: "No courses found text"
  },
  noAboutFound: {
    id: "pages.learning.learner-program.noAboutFound",
    defaultMessage: "This program has no description or about section",
    description: "No about found text"
  },
  about: {
    id: "pages.learning.learner-program.about",
    defaultMessage: "About Program",
    description: "About Program title"
  },
  description: {
    id: "pages.learning.learner-program.description",
    defaultMessage: "Description",
    description: "Description title"
  },
  noDescriptionFound: {
    id: "pages.learning.learner-program.noDescriptionFound",
    defaultMessage: "No description found",
    description: "No description found text"
  }
});

export default messages;